export default "__VITE_ASSET__CG3o93$9__"